import { Component, OnInit , AfterViewInit, ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-division-dept-grid',
  templateUrl: './division-dept-grid.component.html',
  styleUrls: ['./division-dept-grid.component.css']
})
export class DivisionDeptGridComponent implements OnInit {

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  dtOptions: any = {};
  constructor() { }

  ngOnInit(): void {
    this.dtOptions = {
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          className: 'btn btn-radius',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', className: 'btn btn-radius' }
      ],
    }
  }
  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.columns().every(function () {
        const that = this;
        $('input', this.footer()).on('keyup change', function () {
          if (that.search() !== this['value']) {
            that
              .search(this['value'])
              .draw();
          }
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/ultilities/division-department/division-dept-grid/division-dept-grid.component.ts